import { render, staticRenderFns } from "./pressing.vue?vue&type=template&id=59a9b040&scoped=true"
import script from "./pressing.vue?vue&type=script&lang=js"
export * from "./pressing.vue?vue&type=script&lang=js"
import style0 from "./pressing.vue?vue&type=style&index=0&id=59a9b040&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a9b040",
  null
  
)

export default component.exports